import { render, staticRenderFns } from "./TodoFilters.vue?vue&type=template&id=4510443f&"
import script from "./TodoFilters.vue?vue&type=script&lang=js&"
export * from "./TodoFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4510443f')) {
      api.createRecord('4510443f', component.options)
    } else {
      api.reload('4510443f', component.options)
    }
    module.hot.accept("./TodoFilters.vue?vue&type=template&id=4510443f&", function () {
      api.rerender('4510443f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/todo/TodoFilters.vue"
export default component.exports